import React from "react";
import { Link } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import WaitlistForm from "@/components/WaitlistForm";

export default function WaitlistPage() {
  return (
    <div className="club-theme min-h-screen" data-testid="waitlist-page">
      <PublicHeader />
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 pb-12">
        <div className="bloom-divider mb-6">✦ Chapter III · For Members ✦</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] max-w-3xl">
          Join the <em>waitlist</em>.
        </h1>
        <p className="font-serif italic text-xl text-[var(--bloom-ink-soft)] mt-6 max-w-2xl">
          Summer 2027 subscriptions open soon. Pop your details below and we'll let you know
          the moment your area opens up. Boxes are limited per region.
        </p>
      </section>
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-24">
        <WaitlistForm />
        <p className="text-center font-serif italic text-[var(--bloom-ink-soft)] mt-10">
          Looking to grow with us? <Link to="/become-a-grower" className="underline">Apply to become a Founding Grower →</Link>
        </p>
      </section>
      <PublicFooter />
    </div>
  );
}
